// EL translations
export const translations = {
"modal.title": "Πείτε μας για αυτά τα θέματα",
"modal.subtitle":
  "Καταλαβαίνουμε κάθε γλώσσα, συμπληρώνουμε τα πάντα και μεταφράζουμε αν χρειαστεί",

"loader.initial": "Προετοιμασία φόρμας...",

// Dynamic progress stages for initAnalyze loading
"loader.stage1": "Ανάλυση πεδίων φόρμας...",
"loader.stage2": "Ανίχνευση γλώσσας...",
"loader.stage3": "Αναγνώριση ευαίσθητων πεδίων...",
"loader.stage4": "Προετοιμασία προτάσεων...",
"loader.stage5": "Σχεδόν έτοιμο!",

"button.startSpeaking": "Ξεκινήστε ομιλία",
"button.stopSpeaking": "Διακοπή εγγραφής",
"button.tryAgain": "Δοκιμάστε ξανά",

"listening.title": "Ακρόαση...",
"listening.subtitle": "Μιλήστε φυσικά για αυτό που θέλετε να συμπληρώσετε",
"processing.title": "Επεξεργασία...",

// Dynamic progress stages for processing (voice->text->LLM)
"processing.stage1": "Μετατροπή ομιλίας σε κείμενο...",
"processing.stage2": "Ανίχνευση γλώσσας...",
"processing.stage3": "Κατανόηση του αιτήματός σας...",
"processing.stage4": "Εξαγωγή δεδομένων...",
"processing.stage5": "Αντιστοίχιση με πεδία φόρμας...",
"processing.stage6": "Επικύρωση δεδομένων...",
"processing.stage7": "Προετοιμασία αποτελεσμάτων...",
"processing.stage8": "Σχεδόν έτοιμο!",

"success.title": "Η φόρμα συμπληρώθηκε!",
"success.subtitle":
  "Ελέγξτε τα συμπληρωμένα πεδία και υποβάλετε όταν είστε έτοιμοι",
"success.apply_changes": "Συμπλήρωση και έλεγχος",
"success.empty_fields": "Δεν συμπληρώθηκε",
"success.check_fields": "Έλεγχος",
"success.filled_fields": "Ολοκληρώθηκε",
"success.field_single": "πεδίο",
"success.fields_multiple": "πεδία",
"success.require_attention": "απαιτούν προσοχή",
"success.successfully_filled": "συμπληρώθηκε επιτυχώς",

"empty.title": "Δεν βρέθηκαν συμπληρώσιμα πεδία",
"empty.subtitle": "Αυτή η φόρμα δεν έχει πεδία που μπορούν να συμπληρωθούν με φωνή",

"error.title": "Σφάλμα",
"error.microphone": "Απαιτείται πρόσβαση στο μικρόφωνο",
"error.noFields": "Δεν εντοπίστηκαν φόρμες σε αυτήν τη σελίδα",
"error.noActiveForm": "Δεν βρέθηκε ενεργή φόρμα για συμπλήρωση",
"error.lowConfidence":
  "Δεν μπόρεσα να κατανοήσω καθαρά τον ήχο. Παρακαλώ μιλήστε πιο καθαρά.",
"error.general": "Κάτι πήγε στραβά. Παρακαλώ δοκιμάστε ξανά.",
"error.domainNotAllowed":
  "Αυτός ο τομέας δεν είναι εξουσιοδοτημένος να χρησιμοποιήσει την υπηρεσία. Παρακαλώ επικοινωνήστε με τον διαχειριστή του ιστότοπου.",
"error.invalidApiKey": "Η υπηρεσία δεν έχει ρυθμιστεί σωστά. Επικοινωνήστε με τον διαχειριστή του ιστότοπου.",
"error.rateLimited": "Η υπηρεσία είναι απασχολημένη αυτή τη στιγμή. Δοκιμάστε ξανά σε λίγο.",
"error.quotaExhausted": "Το όριο χρήσης αυτής της υπηρεσίας έχει συμπληρωθεί. Επικοινωνήστε με τον διαχειριστή του ιστότοπου.",
"error.no_fields_detected":
  "Δεν ήταν δυνατή η αναγνώριση πληροφοριών για τη συμπλήρωση της φόρμας. Παρακαλώ προσπαθήστε να προσδιορίσετε πιο καθαρά ποια δεδομένα πρέπει να εισαχθούν στα πεδία.",
"error.no_data_title": "Τα δεδομένα δεν αναγνωρίστηκαν",
"error.mic_title": "Απαιτείται μικρόφωνο",
"error.network_title": "Πρόβλημα σύνδεσης",
"error.showDetails": "Εμφάνιση τεχνικών λεπτομερειών",

"floatingButton.fillByVoice": "Συμπλήρωση με φωνή",

"form.progress.filled": "{count} συμπληρωμένα",
"form.progress.scrollToSelect": "Κύλιση για επιλογή",
"form.formNumber": "{current} από {total}",
"form.allForms": "Όλες οι {count} φόρμες",
"form.label": "Φόρμα",
"form.fields": "Πεδία",
"button.close": "Κλείσιμο",
// Consent modal
"consent.title": "Το Απόρρητο των Δεδομένων σας",
"consent.subtitle":
  "Παρακαλούμε διαβάστε προσεκτικά τις πληροφορίες σχετικά με την προστασία των δεδομένων σας",
"consent.warning_title": "Σημαντικό: Μην Μοιράζεστε Ευαίσθητα Δεδομένα",
"consent.warning":
  "Παρακαλούμε μην αναφέρετε κωδικούς πρόσβασης, στοιχεία πληρωμής, κυβερνητικά αναγνωριστικά ή ιατρικές πληροφορίες. Αυτά τα δεδομένα δεν προορίζονται για επεξεργασία από τη φωνητική λειτουργία.",
"consent.summary_card1_title": "Τι Συλλέγουμε",
"consent.summary_data1": "Ηχογράφηση φωνής → μετατροπή σε κείμενο",
"consent.summary_data2":
  "Ονόματα/τύποι/δείκτες θέσης πεδίων (χωρίς τιμές· ευαίσθητα πεδία εξαιρούνται)",
"consent.summary_data3":
  "Τεχνικά αρχεία καταγραφής (IP, πληροφορίες προγράμματος περιήγησης)",
"consent.summary_card2_title": "Πού Πηγαίνει",
"consent.summary_transfer":
  "OpenAI (ΗΠΑ) για επεξεργασία AI • Google Cloud/Firebase (ΕΕ, Πολωνία) για φιλοξενία και ασφάλεια",
"consent.summary_card3_title": "Τα Δικαιώματά σας",
"consent.summary_rights":
  "Ανάκληση συγκατάθεσης ανά πάσα στιγμή • Αίτημα πρόσβασης ή διαγραφής των δεδομένων σας • Πλήρεις λεπτομέρειες στην <a href='https://webappski.com/en/legal/product-privacy' target='_blank' rel='noopener noreferrer'>Πολιτική Απορρήτου</a>",
"consent.full_details_title": "Ανάγνωση Πλήρων Λεπτομερειών",
"consent.section1_title": "Ποια δεδομένα επεξεργαζόμαστε;",
"consent.data1":
  "Ηχογράφηση φωνής. Το αρχείο ήχου αποστέλλεται στο OpenAI μέσω του διακομιστή μας για μεταγραφή. Το αρχείο δεν αποθηκεύεται στον διακομιστή μετά την επεξεργασία.",
"consent.data2":
  "Μεταγραφή φωνής (κείμενο). Αποστέλλεται στο OpenAI GPT για συμπλήρωση φόρμας. Από προεπιλογή δεν αποθηκεύουμε τη μεταγραφή στα συστήματά μας· στα τεχνικά αρχεία καταγραφής αποθηκεύουμε μόνο μεταδεδομένα (μήκος κειμένου, γλώσσα, διάρκεια). Σημαντικό: Η OpenAI μπορεί να αποθηκεύσει δεδομένα αιτημάτων έως και 30 ημέρες για την αποτροπή κατάχρησης· η πρόωρη διαγραφή στην OpenAI δεν είναι διαθέσιμη· τα δεδομένα δεν χρησιμοποιούνται για εκπαίδευση μοντέλων.",
"consent.data3":
  "Μεταδεδομένα πεδίων φόρμας. Ονόματα/τύποι/δείκτες θέσης (ευαίσθητα πεδία εξαιρούνται).",
"consent.data4":
  "URL σελίδας. Επεξεργάζεται από την υποδομή μας (για συμβατότητα/διαγνωστικά), ΔΕΝ αποστέλλεται στην OpenAI. Παρακαλούμε αποφύγετε προσωπικά δεδομένα σε παραμέτρους ερωτήματος URL.",
"consent.data5":
  "User-Agent προγράμματος περιήγησης. Χρησιμοποιείται τοπικά και από την υποδομή μας (συμβατότητα/ασφάλεια), ΔΕΝ αποστέλλεται στην OpenAI.",
"consent.data6":
  "Διεύθυνση IP. Καταγράφεται από την υποδομή Google Cloud/Firebase για ασφάλεια (έως 30 ημέρες), ΔΕΝ αποστέλλεται στην OpenAI.",
"consent.retention":
  "Πόσο καιρό διατηρούμε την καταγραφή της συγκατάθεσής σας. Η καταγραφή αυτής της συγκατάθεσης αποθηκεύεται για {months} μήνες από την πιο πρόσφατη συγκατάθεσή σας και έπειτα διαγράφεται αυτόματα. Η ανάκληση της συγκατάθεσης τη διαγράφει νωρίτερα.",
"consent.section2_title":
  "Πού και με ποια νομική βάση μεταφέρονται τα δεδομένα;",
"consent.recipients":
  "Παραλήπτες. OpenAI (ΗΠΑ) — επεξεργασία ήχου/κειμένου· Google Cloud/Firebase (ΕΕ/Πολωνία) — φιλοξενία και αρχεία καταγραφής ασφαλείας. Τα δεδομένα δεν χρησιμοποιούνται για εκπαίδευση μοντέλων.",
"consent.transfer1":
  "OpenAI (ΗΠΑ). Τα αιτήματα προς την OpenAI (συμπεριλαμβανομένων ήχου/κειμένου) μπορεί να αποθηκευτούν από την OpenAI έως και 30 ημέρες για την αποτροπή κατάχρησης· τα δεδομένα δεν χρησιμοποιούνται για εκπαίδευση μοντέλων. Μεταφορά στις ΗΠΑ — με βάση τις SCC εγκεκριμένες από την Ευρωπαϊκή Επιτροπή.",
"consent.basis_title": "Νομικές βάσεις:",
"consent.basis1":
  "Φωνητική λειτουργία — η συγκατάθεσή σας (Άρθρο 6(1)(α) GDPR).",
"consent.basis2":
  "Τεχνικά αρχεία καταγραφής (IP/UA/URL) — έννομα συμφέροντα (Άρθρο 6(1)(στ)) — ασφάλεια και αποσφαλμάτωση.",
"consent.section3_title": "Τα δικαιώματά σας",
"consent.rights1":
  "Μπορείτε να ανακαλέσετε τη συγκατάθεσή σας ανά πάσα στιγμή από τον πίνακα «Απόρρητο & Δεδομένα» του widget — η ίδια ενέργεια διαγράφει επίσης τις καταγραφές συγκατάθεσής σας από τους διακομιστές μας. Αυτό δεν επηρεάζει τη νομιμότητα της επεξεργασίας πριν από την ανάκληση.",
"consent.rights2":
  "Εκτός από την ανάκληση συγκατάθεσης, έχετε το δικαίωμα να ζητήσετε πρόσβαση ή διαγραφή των δεδομένων σας που είναι αποθηκευμένα στα συστήματά μας (τεχνικά αρχεία καταγραφής, μετρήσεις κόστους) μέσω του ιδιοκτήτη του ιστότοπου. Πλήρεις λεπτομέρειες στην <a href='https://webappski.com/en/legal/product-privacy' target='_blank' rel='noopener noreferrer'>Πολιτική Απορρήτου</a>.",
"consent.rights3":
  "Αυτή η λειτουργία προορίζεται για χρήστες 16+· για νεότερους χρήστες απαιτείται συγκατάθεση γονέα/κηδεμόνα.",
"consent.footer_legal_title": "Νομικές Πληροφορίες",
"consent.footer_controller":
  "Υπεύθυνος Επεξεργασίας: ο ιδιοκτήτης αυτού του ιστότοπου.",
"consent.footer_processor":
  "TypelessForm: ενεργεί ως εκτελών την επεξεργασία.",
"consent.footer_contact": "Επικοινωνία απορρήτου: info@webappski.com.",
"consent.footer_sccs":
  "Η μεταφορά στις ΗΠΑ πραγματοποιείται βάσει SCC. Οι λεπτομέρειες είναι διαθέσιμες στην <a href='https://webappski.com/en/legal/product-privacy' target='_blank' rel='noopener noreferrer'>Πολιτική Απορρήτου</a> μας.",
"consent.accept": "Αποδέχομαι",

// Consent checkboxes
"consent.checkbox_main": "Συναινώ στην επεξεργασία των φωνητικών μου δεδομένων και των μεταδεδομένων φόρμας από το TypelessForm και στη διεθνή μεταφορά στις ΗΠΑ (OpenAI) σύμφωνα με τα SCC, όπως περιγράφεται στην <a href='https://webappski.com/en/legal/product-privacy' target='_blank' rel='noopener noreferrer'>Πολιτική Απορρήτου</a>.",
"consent.checkbox_age": "Επιβεβαιώνω ότι είμαι 16+ ετών ή έχω τη συγκατάθεση γονέα/κηδεμόνα.",

// Privacy settings / data deletion
"privacy.title": "Απόρρητο & Δεδομένα",
"privacy.subtitle": "Διαχείριση συγκατάθεσης και δεδομένων",
"privacy.info_title": "Η εγγραφή συγκατάθεσής σας",
"privacy.user_id": "Αναγνωριστικό",
"privacy.consent_date": "Συγκατάθεση δόθηκε",
"privacy.policy_version": "Έκδοση πολιτικής",
"privacy.usage_count": "Αριθμός χρήσεων",
"privacy.no_data": "Δεν βρέθηκαν δεδομένα συγκατάθεσης σε αυτή τη συσκευή.",
"privacy.delete_title": "Ανάκληση συγκατάθεσης και διαγραφή των δεδομένων μου",
"privacy.delete_description": "Αυτό θα διαγράψει μόνιμα όλα τα αρχεία συγκατάθεσής σας από τους διακομιστές μας και θα διαγράψει τα τοπικά δεδομένα. Αυτή η ενέργεια δεν μπορεί να αναιρεθεί.",
"privacy.delete_confirm": "Κατανοώ ότι είναι μόνιμο",
"privacy.delete_button": "Ανάκληση συγκατάθεσης και διαγραφή των δεδομένων μου",
"privacy.deleting": "Διαγραφή...",
"privacy.delete_success": "Όλα τα δεδομένα σας διαγράφηκαν επιτυχώς.",
"privacy.delete_error": "Αποτυχία διαγραφής δεδομένων. Δοκιμάστε ξανά ή επικοινωνήστε στο info@webappski.com.",
"privacy.done": "Έτοιμο",
"privacy.link": "Απόρρητο",

"review.autoTranslated": "Αυτόματη μετάφραση",
"review.original": "Πρωτότυπο",
};
